"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFrontendVarsEnvironmentAgnostic = exports.getAllFrontendVars = exports.getFrontendPublicProcessEnvVars = void 0;
const video_lib_bridge_resources_1 = require("@sy/video-lib-bridge-resources");
const commonSharedEnvs = {
    FACEBOOK_DOMAIN_VERIFICATION_CODE: 'psxj3dlzcgpca1olwmmsobkg1fh8b8',
    LINKEDIN_CLIENT_ID: '86rgx8i8l1vkp5',
    PINTEREST_DOMAIN_VERIFICATION_CODE: '56d996171e5e3ec27d26c31155aa5df1',
    RESTREAM_CLIENT_ID: 'a85aa2d9-aed2-416e-98ca-51c5d048ad61',
    STUDIO_API_CVENT_APP_ID: 'v2ftYLuHLOCIuei7QfgXaUk9',
    STUDIO_API_HOPIN_APP_ID: 'vH1io47eNHbeqjJIBdehvW9y',
    STUDIO_API_SOCIO_APP_ID: 'MPkWK2VGXgJmVoLfdSm9EbqC',
    STUDIO_API_TEST_APP_ID: 'qsF6VPM6ezK2ZvuRv36t6Rxh',
    ZENDESK_PUBLIC_ID: '546bcb3c-52ea-42da-aa57-6fb92939c8dd',
    FIRST_PROMOTER_TRACKING_ID: 'xp1iz6o3',
    GTM_ID: 'GTM-5KG4PZD',
};
const beta = {
    ...commonSharedEnvs,
    CLOUD_LOGGER_TOKEN: 'VVg4RjJEcHhWemoxWFhhNlNvRm5vUFNIYmg3dmw2SnEK',
    CLOUD_LOGGER_ENDPOINT: 'https://logger.streamyard.com/SYCloudLogger',
    CLOUD_LOGGER_GCP_PROJECT_ID: 'streamyard-0',
    get COLLAB_OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_collab.png`;
    },
    CUSTOMERIO_CDN_URL: 'https://cio-dev-api.streamyard.com',
    CUSTOMERIO_CLIENT_WRITE_KEY: 'd8f80dae8c0a75e39e24:79c9a9e209ec3213e47f',
    FACEBOOK_CLIENT_ID: `1735742959842222`,
    GOOGLE_CLIENT_ID: `807908323196-8tlqm2fpcueh2oa9ooc061d7bpq4mk32.apps.googleusercontent.com`,
    GUEST_FINDER_STREAMCHAT_KEY: `56sfnnvu4pxg`,
    // Hopin OAuth sy app config
    HOPIN_OAUTH_API_URL: 'https://hopin.com/oauth',
    HOPIN_OAUTH_CLIENT_ID: 'i1Q_B_t60e9EI77lav0MPhiUEsmQSiJGAVisuoh50BI',
    HOPIN_PUSHER_APP_KEY: `d9b03d485c6d62190e94`,
    MOBILE_REDIRECT_URL: 'https://syard.page.link',
    get OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_general_1200x630.png`;
    },
    OG_IMAGE_URL: `https://beta.streamyard.com`,
    ONAIR_STREAMCHAT_KEY: `wduqc973waff`,
    ONETRUST_ID: `0190b665-f3b9-776e-964c-a3f6400cf99a-test`,
    PERISCOPE_CLIENT_ID: `Jdfba8KmAnG56aBUei0ijHoUDEQue6Z-RPaEwvcWjP2089m0f2`,
    FRONTEND_REMOTE_LOGGING_ENABLED: 'true',
    ROLLBAR_CLIENT_TOKEN: `b6684d13cef34cf4b3dc204f0dcd824b`,
    SENTRY_DSN: `https://4d9632b6a45c940f419b19db183ec1a7@o6787.ingest.us.sentry.io/4507458020704257`,
    ASSETS_HOST: 'https://beta.streamyard.com',
    get WEBPACK_PUBLIC_PATH() {
        return `${this.ASSETS_HOST}/static/`;
    },
    STRIPE_API_VERSION: '2020-08-27',
    STRIPE_PUBLIC_KEY: `pk_live_VTzF8If77LnD2HVLhmkIfhbv`,
    TIKTOK_CLIENT_KEY: `awxqw70gn6r84jeg`,
    TWITCH_CLIENT_ID: `kat1b3e69qofb3ssgko7poy4amj3is`,
};
const development = {
    ...commonSharedEnvs,
    CLOUD_LOGGER_ENDPOINT: 'https://logger.dev.streamyard.com/SYCloudLogger',
    CLOUD_LOGGER_TOKEN: 'SGQ3aERtS3E4RVZkcDAzSkg3OTVmN0RnSXlheTRuVlIK',
    CLOUD_LOGGER_GCP_PROJECT_ID: 'streamyard-dev',
    get COLLAB_OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_collab.png`;
    },
    CUSTOMERIO_CDN_URL: 'https://cio-dev-api.streamyard.com',
    CUSTOMERIO_CLIENT_WRITE_KEY: 'd8f80dae8c0a75e39e24:79c9a9e209ec3213e47f',
    FACEBOOK_CLIENT_ID: `228627414484024`,
    GOOGLE_CLIENT_ID: `111314291839-nrr90jvpl0u2gtg3ceh927uah670t600.apps.googleusercontent.com`,
    GUEST_FINDER_STREAMCHAT_KEY: `9hdf5zug4k7f`,
    // Hopin OAuth sy app config
    HOPIN_OAUTH_API_URL: 'https://staging.hopin.com/oauth',
    HOPIN_OAUTH_CLIENT_ID: 'zyZ5bFvnQmjmyvISbdF6kcIkV2wwCl1pJrVAS4T2n0U',
    HOPIN_PUSHER_APP_KEY: `00f26110e245c71efda3`,
    MOBILE_REDIRECT_URL: 'https://streamyarddev.page.link',
    get OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_general_1200x630.png`;
    },
    OG_IMAGE_URL: `https://streamyard.com`,
    ONAIR_STREAMCHAT_KEY: `pq2hfhxgzu52`,
    ONETRUST_ID: `0190b665-f3b9-776e-964c-a3f6400cf99a-test`,
    PERISCOPE_CLIENT_ID: `jouS-o4YDwcbHnsQBK6AWpDDsEvT2Im54-dUc06KPetrsbnzkm`,
    ROLLBAR_CLIENT_TOKEN: ``,
    SENTRY_DSN: `https://4d9632b6a45c940f419b19db183ec1a7@o6787.ingest.us.sentry.io/4507458020704257`,
    get ASSETS_HOST() {
        return process.env.ASSETS_HOST_OVERRIDE || 'https://dev.streamyard.com';
    },
    get WEBPACK_PUBLIC_PATH() {
        return `${this.ASSETS_HOST}/static/`;
    },
    STRIPE_API_VERSION: '2020-08-27',
    STRIPE_PUBLIC_KEY: `pk_test_rnIWGI0gQrjPKrLqkZB8NFtM`,
    TIKTOK_CLIENT_KEY: `aw57fgajw79znvn3`,
    TWITCH_CLIENT_ID: `xt0slv6wa0e06g5odq53kzla47ryqz`,
    FRONTEND_REMOTE_LOGGING_ENABLED: 'false',
};
const production = {
    ...commonSharedEnvs,
    CLOUD_LOGGER_ENDPOINT: 'https://logger.streamyard.com/SYCloudLogger',
    CLOUD_LOGGER_TOKEN: 'VVg4RjJEcHhWemoxWFhhNlNvRm5vUFNIYmg3dmw2SnEK',
    CLOUD_LOGGER_GCP_PROJECT_ID: 'streamyard-0',
    get COLLAB_OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_collab.png`;
    },
    CUSTOMERIO_CDN_URL: 'https://cio-prod-api.streamyard.com',
    CUSTOMERIO_CLIENT_WRITE_KEY: '09b56014bbdd86e06884:6f593fd6f6f2b9e1cf3e',
    FACEBOOK_CLIENT_ID: `1735742959842222`,
    GOOGLE_CLIENT_ID: `807908323196-8tlqm2fpcueh2oa9ooc061d7bpq4mk32.apps.googleusercontent.com`,
    GUEST_FINDER_STREAMCHAT_KEY: `56sfnnvu4pxg`,
    // Hopin OAuth sy app config
    HOPIN_OAUTH_API_URL: 'https://hopin.com/oauth',
    HOPIN_OAUTH_CLIENT_ID: 'i1Q_B_t60e9EI77lav0MPhiUEsmQSiJGAVisuoh50BI',
    HOPIN_PUSHER_APP_KEY: `d9b03d485c6d62190e94`,
    MOBILE_REDIRECT_URL: 'https://syard.page.link',
    get OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_general_1200x630.png`;
    },
    OG_IMAGE_URL: `https://streamyard.com`,
    ONAIR_STREAMCHAT_KEY: `wduqc973waff`,
    ONETRUST_ID: `0190b665-f3b9-776e-964c-a3f6400cf99a`,
    PERISCOPE_CLIENT_ID: `Jdfba8KmAnG56aBUei0ijHoUDEQue6Z-RPaEwvcWjP2089m0f2`,
    FRONTEND_REMOTE_LOGGING_ENABLED: 'true',
    ROLLBAR_CLIENT_TOKEN: `b6684d13cef34cf4b3dc204f0dcd824b`,
    SENTRY_DSN: `https://4d9632b6a45c940f419b19db183ec1a7@o6787.ingest.us.sentry.io/4507458020704257`,
    ASSETS_HOST: 'https://streamyard.com',
    get WEBPACK_PUBLIC_PATH() {
        return `${this.ASSETS_HOST}/static/`;
    },
    STRIPE_API_VERSION: '2020-08-27',
    STRIPE_PUBLIC_KEY: `pk_live_VTzF8If77LnD2HVLhmkIfhbv`,
    TIKTOK_CLIENT_KEY: `awxqw70gn6r84jeg`,
    TWITCH_CLIENT_ID: `kat1b3e69qofb3ssgko7poy4amj3is`,
};
const staging = {
    ...commonSharedEnvs,
    CLOUD_LOGGER_ENDPOINT: 'https://logger.staging.streamyard.com/SYCloudLogger',
    CLOUD_LOGGER_TOKEN: 'VGZISVp1dmR1bUlHdTRTWVBzWWZGWTluYkFtRWh6SEMK',
    CLOUD_LOGGER_GCP_PROJECT_ID: 'streamyard-staging',
    get COLLAB_OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_collab.png`;
    },
    CUSTOMERIO_CDN_URL: 'https://cio-dev-api.streamyard.com',
    CUSTOMERIO_CLIENT_WRITE_KEY: 'd8f80dae8c0a75e39e24:79c9a9e209ec3213e47f',
    // dev in use
    FACEBOOK_CLIENT_ID: `228627414484024`,
    // dev google client id; maybe this should be changed to the production one?
    GOOGLE_CLIENT_ID: `111314291839-nrr90jvpl0u2gtg3ceh927uah670t600.apps.googleusercontent.com`,
    GUEST_FINDER_STREAMCHAT_KEY: `aq7ektsuq5ww`,
    // Hopin OAuth sy app config
    HOPIN_OAUTH_API_URL: 'https://staging.hopin.com/oauth',
    HOPIN_OAUTH_CLIENT_ID: 'zyZ5bFvnQmjmyvISbdF6kcIkV2wwCl1pJrVAS4T2n0U',
    HOPIN_PUSHER_APP_KEY: `00f26110e245c71efda3`,
    MOBILE_REDIRECT_URL: 'https://streamyardstaging.page.link',
    get OG_IMAGE_PATH() {
        return `${this.ASSETS_HOST}/images/v1/og_general_1200x630.png`;
    },
    OG_IMAGE_URL: `https://staging.streamyard.com`,
    ONAIR_STREAMCHAT_KEY: `va7vyeb7dh2x`,
    ONETRUST_ID: `0190b665-f3b9-776e-964c-a3f6400cf99a-test`,
    // prod in use
    PERISCOPE_CLIENT_ID: `Jdfba8KmAnG56aBUei0ijHoUDEQue6Z-RPaEwvcWjP2089m0f2`,
    FRONTEND_REMOTE_LOGGING_ENABLED: 'true',
    // Rollbar prod token; we tell Rollbar what the error's environment is
    ROLLBAR_CLIENT_TOKEN: 'b6684d13cef34cf4b3dc204f0dcd824b',
    SENTRY_DSN: `https://4d9632b6a45c940f419b19db183ec1a7@o6787.ingest.us.sentry.io/4507458020704257`,
    ASSETS_HOST: 'https://staging.streamyard.com',
    get WEBPACK_PUBLIC_PATH() {
        return `${this.ASSETS_HOST}/static/`;
    },
    STRIPE_API_VERSION: '2020-08-27',
    // Stripe test key
    STRIPE_PUBLIC_KEY: `pk_test_rnIWGI0gQrjPKrLqkZB8NFtM`,
    // Tiktok dev key
    TIKTOK_CLIENT_KEY: `aw57fgajw79znvn3`,
    // Twitch dev key
    TWITCH_CLIENT_ID: `xt0slv6wa0e06g5odq53kzla47ryqz`,
};
const stagingEu = cloneConfig(staging, {
    OG_IMAGE_URL: `https://stagingeu.streamyard.com`,
    ASSETS_HOST: 'https://stagingeu.streamyard.com',
});
const defaultEnvs = {
    beta,
    development,
    production,
    staging,
    'staging-eu': stagingEu,
};
// These are accessible to all browser clients. DO NOT EXPOSE SECRETS.
const EXPOSED_ENV_KEYS = [
    'CLOUD_LOGGER_ENDPOINT',
    'CLOUD_LOGGER_TOKEN',
    'CLOUD_LOGGER_GCP_PROJECT_ID',
    'CUSTOMERIO_CDN_URL',
    'CUSTOMERIO_CLIENT_WRITE_KEY',
    'GTM_ID',
    'GOOGLE_CLIENT_ID',
    'FACEBOOK_CLIENT_ID',
    'GUEST_FINDER_STREAMCHAT_KEY',
    'HOPIN_OAUTH_API_URL',
    'HOPIN_OAUTH_CLIENT_ID',
    'HOPIN_PUSHER_APP_KEY',
    'LINKEDIN_CLIENT_ID',
    'MOBILE_REDIRECT_URL',
    'ONAIR_STREAMCHAT_KEY',
    'PERISCOPE_CLIENT_ID',
    'FRONTEND_REMOTE_LOGGING_ENABLED',
    'RESTREAM_CLIENT_ID',
    'ROLLBAR_CLIENT_TOKEN',
    'SENTRY_DSN',
    'STRIPE_PUBLIC_KEY',
    'STUDIO_API_CVENT_APP_ID',
    'STUDIO_API_HOPIN_APP_ID',
    'STUDIO_API_SOCIO_APP_ID',
    'STUDIO_API_TEST_APP_ID',
    'TIKTOK_CLIENT_KEY',
    'TWITCH_CLIENT_ID',
    'ZENDESK_PUBLIC_ID',
    'FIRST_PROMOTER_TRACKING_ID',
    'ONETRUST_ID',
    'PINTEREST_DOMAIN_VERIFICATION_CODE',
    'FACEBOOK_DOMAIN_VERIFICATION_CODE',
    'WEBPACK_PUBLIC_PATH',
    'ASSETS_HOST',
];
const EXTRA_EXPOSED_ENV_KEYS = [
    'TARGET_ENVIRONMENT',
    'CODE_SHA',
    'SENTRY_RELEASE',
];
function cloneConfig(config, overrides = {}) {
    const newConfig = {};
    Object.defineProperties(newConfig, Object.getOwnPropertyDescriptors(config));
    if (Object.keys(overrides).length) {
        Object.assign(newConfig, overrides);
    }
    return newConfig;
}
function getFrontendPublicProcessEnvVars(environment) {
    if (!environment) {
        return null;
    }
    const envVars = defaultEnvs[environment];
    const partialPublicEnvVars = Object.keys(envVars)
        .filter(key => EXPOSED_ENV_KEYS.includes(key))
        .reduce((dict, key) => {
        // eslint-disable-next-line no-param-reassign
        dict[key] = envVars[key];
        return dict;
    }, {});
    const publicProcessEnv = {
        ...partialPublicEnvVars,
        ...(0, video_lib_bridge_resources_1.getVideoLibFrontendVars)(environment),
        TARGET_ENVIRONMENT: environment,
        CODE_SHA: process.env.CODE_SHA || 'development',
        SENTRY_RELEASE: process.env.SENTRY_RELEASE || 'development',
    };
    if (process.env.FRONTEND_REMOTE_LOGGING_ENABLED) {
        publicProcessEnv.FRONTEND_REMOTE_LOGGING_ENABLED =
            process.env.FRONTEND_REMOTE_LOGGING_ENABLED;
    }
    return publicProcessEnv;
}
exports.getFrontendPublicProcessEnvVars = getFrontendPublicProcessEnvVars;
function getAllFrontendVars(environment) {
    if (!environment) {
        return null;
    }
    return defaultEnvs[environment];
}
exports.getAllFrontendVars = getAllFrontendVars;
function getFrontendVarsEnvironmentAgnostic() {
    return commonSharedEnvs;
}
exports.getFrontendVarsEnvironmentAgnostic = getFrontendVarsEnvironmentAgnostic;
//# sourceMappingURL=constantsPerEnvironment.js.map